import { render, staticRenderFns } from "./ContentPanel.vue?vue&type=template&id=33489434&scoped=true&"
import script from "./ContentPanel.vue?vue&type=script&lang=js&"
export * from "./ContentPanel.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/contentPanel.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33489434",
  null
  
)

export default component.exports